import { AppState } from '../../types'

const selectors: any = {
  getAll: (state: AppState) => state.monitoring.emptyState,
  is404: (state: AppState) => selectors.getAll(state).is404,
  emptyStateTitle: (state: AppState) => selectors.getAll(state).emptyStateTitle,
  emptyStateSubtitle: (state: AppState) => selectors.getAll(state).emptyStateSubtitle,
  redirectLink: (state: AppState) => selectors.getAll(state).redirectLink
}

export default selectors
